<template>
  <div id="app" class="bg-light container-lg ">
    <a href="http://www.iranology.ir" target="_blank"><img alt="Iranology Foundation" src="image/svg/iranology.svg"></a>
    <a href="http://woman.iranology.ir" target="_blank"><img alt="Iranology Foundation" src="image/zan/zanLogo.png" class="float-left"></a>
<!--    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <router-view></router-view>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  data(){
    return{
      // content:[
      //   {id:1,title:'\n' +
      //             '            هدف اصلی از برگزاری همایش بین‌المللی «جایگاه زن در تمدن ایران و اسلام»؛<br/>\n' +
      //             '            آغاز گفتگوی جهانی با متفکران عالم برای بیان شأن واقعی زن و تدوین قوانینی<br/>\n' +
      //             '            جهت حفظ این شأن بر مبنای تاریخ ایران و اسلام است'}
      // ]
    }
  }
}
</script>

<style lang="scss" >
  @import "_App.scss";
#app {
  font-family: Naskh, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  margin-top: 30px;
  border-radius: 15px;
  padding: 25px;
}
</style>
